var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.thumb)?[_c('canvas',{attrs:{"id":"canvas"}}),_c('div',{attrs:{"id":"bg"}})]:_vm._e(),_c('router-view'),(_vm.istab)?_c('CustomTabBar'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }